var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"myBox",staticClass:"Checkbox",style:({ width: (_vm.clientWidth + "px") }),on:{"click":function($event){return _vm.$emit('check')}}},[(_vm.selected)?_c('img',{attrs:{"src":require("../../../assets/icons/check.svg")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }